<template>
    <Header ueberschrift="LP-THL Sprüche" />
    <div id="lp-thl">
        <h2>Angriffstrupp:</h2>
        <p>Zum Einsatz fertig!</p>
        <p>Angriffstrupp einsatzbereit!</p>
        <p>Angriffstrupp zum Sichern der A- und B-Säule beidseitig mit Unterbaumaterial und Unterlegkeilen zum Unfallfahrzeug vor!</p>
        <p>Unfallfahrzeug sicher unterbaut!</p>
        <p>Angriffstrupp mit Spreizer und Schneidgerät zur Personenbefreiung vor, Schlauchtrupp unterstützt, Schrottablage hinter dem Unfallfahrzeug am Fahrbahnrand!</p>
        <p>Hydraulikpumpe ein!</p>
        <p>Hydraulikpumpe aus!</p>
        <hr>
        <h2>Wassertrupp:</h2>
        <p>Wassertrupp einsatzbereit!</p>
        <p>Wassertrupp zur Sicherung gegen Brandgefahr mit Schnellangriff und Pulverlöscher auf Höhe Geräteablage am Fahrbahnrand vor!</p>
        <hr>
        <h2>Schlauchtrupp:</h2>
        <p>Schlauchtrupp einsatzbereit!</p>
        <p>Hydraulikpumpe ein!</p>
        <p>Hydraulikpumpe aus!</p>
        <hr>
        <h2>Gruppenführer:</h2>
        <p>FF Poppenhausen, Einsatzstelle an</p>
        <p>Absitzen</p>
        <p>Verkehrsunfall mit eingeklemmter Person,
            Melder übernimmt die Erstversorgung,
            Wassertrupp erstellt Verkehrsabsicherung,
            Maschinist übernimmt Einsatzstellenbeleuchtung mit Lichtmast,
            Angriffstrupp und Schlauchtrupp, Aufbau der Geräteablage ca. 5 Meter vor dem Unfallfahrzeug!
        </p>
        <p>Zum Einsatz fertig!</p>
        <p>Angriffstrupp zum Sichern der A- und B-Säule beidseitig mit Unterbaumaterial und Unterlegkeilen zum Unfallfahrzeug vor!</p>
        <p>Wassertrupp zur Sicherung gegen Brandgefahr mit Schnellangriff und Pulverlöscher auf Höhe Geräteablage am Fahrbahnrand vor!</p>
        <p>Angriffstrupp mit Spreizer und Schneidgerät zur Personenbefreiung vor, Schlauchtrupp unterstützt, Schrottablage hinter dem Unfallfahrzeug am Fahrbahnrand!</p>
        <p>Person befreit, Rettungsdienst übergeben</p>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'lp-thl',
    components: {
        Header,
        Footer
    },
    data() {
        return {

        }
    },
    methods: {

    },
    created() {
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
#lp-thl{
    display: block !important;
    position:absolute !important;
    height:auto !important;
    bottom:0 !important;
    top:0 !important;
    left:0 !important;
    right:0 !important;
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 4.5rem;
    height: 72vh;
    overflow-y: scroll;
    background-color: white;
}
</style>